import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MatDialog} from '@angular/material/dialog';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {ImportFileDialogComponent} from '../createfromopenapi/import-file-dialog/import-file-dialog.component';
import { FormControl } from '@angular/forms';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {interval, Observable} from 'rxjs';
import {AddServiceProviderComponent} from '../landing-page/detail/detail.component';

@Component({
  selector: 'app-postman-collections',
  templateUrl: './postman-collections.component.html',
  styleUrls: ['./postman-collections.component.scss']
})
export class PostmanCollectionsComponent implements OnInit {
  title = 'app';
  code: string;
  deploymentPlan: any;
  origDeploymentPlan: any;
  apiExecutorPlans: any;
  entityPlans: any;
  dataMigrationPlans: any;
  applicationData: any;
  categoriesData: any;
  showInputPanel = true;
  showNextPanel = false;
  showDeploymentPlan = false;
  databases: any;
  defaultDatabase = 'default';
  executorTypes = [
    {display_name: 'Third Party API', executor_type: 'THIRDPARTY'},
  ];

  importAsTypes = [
    {
      displayName: 'Create APIs',
      value: 'BUSINESSLOGIC'
    },
    {
      displayName: 'Register Thirdparty APIs',
      value: 'THIRDPARTY'
    }
  ];
  registerAsTypes = [
    {
      displayName: 'Register As Is',
      value: true
    },
    {
      displayName: 'Secure with apiplatform.io',
      value: false
    }
  ];
  apiVersionInput = 'v1';
  importASInput = 'THIRDPARTY';
  serviceprovider = '';
  registerAsIs = true;
  inputformControl: FormControl = new FormControl({}, []);

  gateways = [
    {
      gateway_name: 'default',
      gateway_type: 'apiplatform'
    }
  ];
  selectGateway = 'default';

  serviceProviders: any;

  postmanCollectionVersionInput = '2.1';
  postmanCollectionVersions = [
    {display_name: 'v2.1', value: '2.1'},
  ];
  options = {
    theme: 'vs-dark',
    language: 'yaml',
    automaticLayout: true
  };
  loading = false;

  componentLoading = false;
  editFlag = false;
  apiExecutors: any;
  entities: any;
  applicationEntries: any;

  pkey = localStorage.getItem('partnerKey');
  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  settingsData: any;

  executorKeys = ['dataroot', 'executor_type', 'executor_name', 'executor_version', 'executor_display_name', 'executor_description', 'executor_category', 'executor_category_group', 'service_provider', 'executor_scope', 'partner', 'account_id', 'executor_method_type', 'apiUrl', 'pathParams', 'queryParams', 'headers', 'authModel', 'requestBody', 'prerequisites', 'published', 'scopeOfAccess', 'registeredAsIs']

  jsonEditorOptions = new JsonEditorOptions();
  @ViewChild('editor') editor: JsonEditorComponent;

  constructor(private confPost: ConfService,
              private _service: ConnecttocrudService,
              public dialog: MatDialog,
              public platform: LeftpanelComponent,
              private location: Location,
              private route: ActivatedRoute) {
    this.jsonEditorOptions.mode = 'code';
    this.jsonEditorOptions.modes = ['code', 'text', 'tree', 'view'];
    this.jsonEditorOptions.schema = '';
    this.jsonEditorOptions.statusBar = false;
    this.jsonEditorOptions.onChange = () => console.log( /*this.editor.get()*/ );
  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.retrievePartnerServiceProviders(true);
    const permissionSubscription = interval(500).subscribe((async x => {
      this.componentLoading = false;
      permissionSubscription.unsubscribe();
    }));
  }

  importAsChange() {
    if (this.importASInput === 'THIRDPARTY') {
      this.executorTypes = [
        {display_name: 'Third Party API', executor_type: 'THIRDPARTY'},
      ];
      this.registerAsIs = true;
    } else {
      this.executorTypes = [
        {display_name: 'Business Logic API', executor_type: 'BUSINESSLOGIC'},
        {display_name: 'SQL Query API', executor_type: 'SQLQUERY'},
        {display_name: 'Workflow API', executor_type: 'WORKFLOW'},
        // {display_name: 'PLSQL API', executor_type: 'PLSQL'},
        // {display_name: 'Third Party API', executor_type: 'THIRDPARTY'},
      ];
      this.registerAsIs = false;
    }
  }

  addServiceProvider() {
    // e.stopPropagation();
    const dialogRef = this.dialog.open(AddServiceProviderComponent, {
      height: 'auto',
      width: '60%',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== undefined) {
        this.retrievePartnerServiceProviders(true, 4000);
      }
    });
  }

  retrievePartnerServiceProviders(loader, timeout = 0) {
    let loaderDialog: any;
    if (loader) {
      loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
    }
    setTimeout(() => {
      this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(settingsData => {
        if (loader) {
          loaderDialog.close();
        }
        this.settingsData = settingsData;
        this.platform.settingsData = settingsData;
        this.serviceProviders = [];
        if (this.settingsData['body'][0]) {
          for (const provider of this.settingsData['body'][0]['subscriptions']['providers']) {
            if ((provider.partner === this.partner && provider.account === this.account && this.partner !== 'services' && this.partner !== 'b2b') ||
                (this.partner === 'b2b' && (provider.partner === this.partner || provider.partner === 'services') && (provider.account === this.account || provider.account  === 'services'))) {
              this.serviceProviders.push(provider);
            }
          }
        }
      }, error => {
        if (loader) {
          loaderDialog.close();
        }
        this.platform.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }, timeout);
  }

  buildDeploymentPlanForPostmanCollection() {
    this.loading = true;
    if (this.code === undefined) {
      this.loading = false;
      alert('Enter Postman Collection');
    } else {
      if (this.editor.isValidJson()) {
        if (this.apiVersionInput && this.apiVersionInput !== '' && ((this.importASInput === 'THIRDPARTY' && this.serviceprovider && this.serviceprovider !== '') || this.importASInput !== 'THIRDPARTY')) {
          this.confPost.buildDeploymentPlanForPostmanCollection(this.partner, this.account, this.editor.get(), this.postmanCollectionVersionInput, this.apiVersionInput, this.importASInput, this.importASInput === 'THIRDPARTY' ? this.serviceprovider : this.partner, this.importASInput === 'THIRDPARTY' ? this.registerAsIs : false).subscribe(data => {
            this.deploymentPlan = data;
            if (this.deploymentPlan) {
              this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
              this.entityPlans = this.deploymentPlan.entityDeploymentPlans ? this.deploymentPlan.entityDeploymentPlans : [];
              this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
              // this.applicationData = this.deploymentPlan.application;
              // this.categoriesData = this.deploymentPlan.categories;
              // if (!this.applicationData.license) {
              //   this.applicationData['license']['name'] = '';
              //   this.applicationData['license']['url'] = '';
              // }
              // if (!this.applicationData.license) {
              //   this.applicationData['license']['name'] = '';
              //   this.applicationData['license']['url'] = '';
              // }
              // if (!this.applicationData.servers) {
              //   this.applicationData['servers'] = [];
              // }
              // if (!this.applicationData.summary) {
              //   this.applicationData['summary'] = '';
              // }
              this.showDeploymentPlan = true;
              this.showInputPanel = false;
              this.showNextPanel = false;

              for (const entity of this.entityPlans) {
                entity['deploy_api'] = true;
                entity['override_api'] = entity.isAvailable;
              }

              for (const executor of this.apiExecutorPlans) {
                executor['deploy_api'] = true;
                if (executor.isAvailable) {
                  executor['deploy_api'] = false;
                }
                // executor['override_api'] = executor.isAvailable;
              }
            } else {
              this.loading = false;
            }
          }, error => {
            this.loading = false;
            this.platform.handleErrorGracefully(error, 'Please enter a valid postman collection.');
          });
        } else {
          this.loading = false;
          this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      } else {
        this.loading = false;
        this.platform.openSnackBar('Please enter a valid postman collection.', 'Error', {
          duration: 8000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }
  }

  updateTypeForExecutor(event, i) {
    const type = event.value;
    // Object.keys(this.deploymentPlan.executorModelDeploymentPlans[i].apiExecutor).forEach((key) => this.executorKeys.includes(key) || delete this.deploymentPlan.executorModelDeploymentPlans[i].apiExecutor[key]);
    if (type === 'SQLQUERY' || type === 'PLSQL') {
      this.deploymentPlan.executorModelDeploymentPlans[i].apiExecutor['executors'] = [
        {
          'database': {
            'database_name': '',
            'database_type': ''
          },
          'query': ''
        }
      ];
    }
  }

  refreshComponent() {
    this.showNextPanel = false;
    this.showDeploymentPlan = true;
    this.showInputPanel = false;
    this.loading = false;
  }

  openFileUploadDialog() {
    const dialogRef = this.dialog.open(ImportFileDialogComponent, {
      height: '60%',
      width: '40%'
    });
    dialogRef.afterClosed().subscribe(async file => {
      if (file) {
        const reader = new FileReader();
        // this.modeler.importXML(file, value => this.handleError(value));
        reader.addEventListener('load', (event: any) => {
          try {
            this.code = JSON.parse(event.target.result.toString());
          } catch (e) {
            // console.log(e);
            this.platform.openSnackBar('Please upload a valid file.', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        });
        reader.readAsText(file);
      }
    });
  }

  toggleOverride(event, api) {
    api.deploy_api = event.checked;
  }

  toggleOverrideForSelected(event, api) {
    if (api.isAvailable) {
      api.override_api = event.checked;
    }
  }

  createPaddingRight() {
    document.getElementById('view:postman_collections').style.paddingRight = '400px';
  }

  removePaddingRight() {
    document.getElementById('view:postman_collections').style.paddingRight = '0px';
  }
}
